/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';

/**
 * 
 * @export
 * @interface CreateOrUpdateUnitDto
 */
export interface CreateOrUpdateUnitDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateUnitDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateUnitDto
     */
    abbreviation: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateUnitDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOrUpdateUnitDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof CreateOrUpdateUnitDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateUnitDto
     */
    $type?: CreateOrUpdateUnitDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateUnitDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoCreateOrUpdateUnitDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.CreateOrUpdateUnitDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateUnitDtoTypeEnum = typeof CreateOrUpdateUnitDtoTypeEnum[keyof typeof CreateOrUpdateUnitDtoTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateUnitDto interface.
 */
export function instanceOfCreateOrUpdateUnitDto(value?: unknown): value is CreateOrUpdateUnitDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateUnitDtoTypeEnum)[0];
}

export function CreateOrUpdateUnitDtoFromJSON(json: any): CreateOrUpdateUnitDto {
    return CreateOrUpdateUnitDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateUnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateUnitDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'abbreviation': json['abbreviation'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateOrUpdateUnitDtoToJSON(value?: CreateOrUpdateUnitDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'name': value.name,
        'abbreviation': value.abbreviation,
        'description': value.description,
        'isAvailable': value.isAvailable,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        '$type': value.$type,
    });
}

